import React, { ReactNode } from "react";

import { Button } from "@xometry/xometry_loft";
import BackButton from "./components/BackButton";
import ErrorImage from "./images/Error.svg";
import ViewSupplierDirectoryButton from "./components/ViewSupplierDirectoryButton";

import { Wrapper } from "./ErrorState.style";
import RefreshButton from "./components/RefreshButton";
import { useConfig } from "../proposals/contexts/configContext";

const ErrorState = ({
  title,
  errorCode,
  children,
}: {
  title: string;
  errorCode?: string;
  children: ReactNode;
}): React.ReactElement => {
  return (
    <div css={Wrapper} data-testid="error-panel">
      <div className="errorPanel">
        <div className="errorText">
          <img src={ErrorImage} alt="" />
          <h1>{title}</h1>
          {children}
          {errorCode && `Error Code: ${errorCode}`}
        </div>
      </div>
    </div>
  );
};

ErrorState.defaultProps = {
  errorCode: "",
};

export const NotFoundError = (): React.ReactElement => (
  <ErrorState title="This page could not be found.">
    <ViewSupplierDirectoryButton />
  </ErrorState>
);

export const PermissionRequired = (): React.ReactElement => (
  <ErrorState title="Permission needed to view this page.">
    <p>
      You do not have permission to view this page, please continue to the
      Supplier Directory.
    </p>
    <ViewSupplierDirectoryButton />
  </ErrorState>
);

export const UnknowError = (): React.ReactElement => (
  <ErrorState title="Something went wrong.">
    <p>An unexpected error occurred while trying to access this page.</p>
    <BackButton />
  </ErrorState>
);

export const KnownError = ({
  title,
  errorMessage,
}: {
  title: string;
  errorMessage: string;
}): React.ReactElement => (
  <ErrorState title={title || "Something went wrong."}>
    <p>
      {errorMessage ||
        "An unexpected error occurred while trying to access this page."}
    </p>
    <BackButton />
  </ErrorState>
);

export const StreamError = (): React.ReactElement => (
  <ErrorState title="Something went wrong.">
    <p>There was an issue submitting the project. Please try again.</p>
    <RefreshButton />
  </ErrorState>
);

export const KnownThomasError = ({
  title,
  errorMessage,
}: {
  title: string;
  errorMessage: string;
}): React.ReactElement => {
  const { origins } = useConfig();
  return (
    <ErrorState title={title || "Something went wrong."}>
      <p>
        {errorMessage ||
          "An unexpected error occurred while trying to access this page."}
      </p>
      <Button
        kind="primary"
        size="large"
        onClick={() => {
          window.location.href = origins.thomasnetHome;
        }}
      >
        Return to Thomas
      </Button>
    </ErrorState>
  );
};

export default ErrorState;
